<template>
  <main class="financial-aid-article">
    <article class="financial-aid-article__article">
      <z-title
        class="z-my-0000"
        align="left"
        size="large"
        tag="h1"
      >
        {{ page.title }}
      </z-title>

      <template v-for="(section, index) in page.content">
        <component
          :is="widgetDictionary[section.widget]"
          :key="index"
          :class="sectionType(section.widget)"
          :pagination="section.widget == 'widget-pagination' ? pagination : undefined"
          v-bind="section"
        />
        <WidgetEnemCard
          v-if="isEnemDigital && index === 0"
          :key="`enem-card-${index}`"
          class="financial-aid-article__widget-enem-card"
        />
      </template>
    </article>

    <aside class="financial-aid-article__aside">
      <template v-for="(section, index) in page.sidebar">
        <component
          :is="widgetDictionary[section.widget]"
          :key="index"
          v-bind="section"
        />
      </template>

      <WidgetEnemCard
        v-if="isEnemDigital"
        class="financial-aid-article__aside-enem-card"
      />
    </aside>
  </main>
</template>

<script>
import WidgetBestSellingIes from '~/components/widget/widget-best-selling-ies.vue'
import WidgetFinancialAid from '~/components/widget/widget-financial_aid'
import WidgetNotaQuero from '~/components/widget/widget-nota_quero'
import WidgetPagination from '~/components/widget/widget-pagination'
import WidgetSearch from '~/components/widget/widget-search_cta'
import WidgetText from '~/components/widget/widget-text'
import WidgetEnemCard from '~/components/widget/widget-enem-card.server.vue'

import { slugify } from '~/assets/js/utils/slug'

export default {
  name: 'FinancialAidArticle',

  components: {
    WidgetBestSellingIes,
    WidgetFinancialAid,
    WidgetNotaQuero,
    WidgetPagination,
    WidgetSearch,
    WidgetText,
    WidgetEnemCard,
  },

  props: {
    page: {
      type: Object,
      required: true,
    },
    isEnemDigital: {
      type: Boolean,
      default: false,
    },
  },

  head () {
    return {
      script: [{
        type: 'application/ld+json',
        json: {
          '@type': 'FAQPage',
          '@context': 'https://schema.org',
          mainEntity: this.page.content.filter(({ title }) => title).map(({ title, content }) => ({
            '@type': 'Question',
            id: `enem/#${slugify(title)}`,
            name: title,
            acceptedAnswer: {
              '@type': 'Answer',
              text: content,
            },
          })),
        },
      }],
    }
  },

  computed: {
    widgetDictionary () {
      return {
        text: WidgetText,
        'best-selling-ies': WidgetBestSellingIes,
        'widget-search-cta': WidgetSearch,
        'widget-nota-quero': WidgetNotaQuero,
        'widget-simulator': WidgetFinancialAid,
        'widget-pagination': WidgetPagination,
      }
    },

    pagination () {
      return {
        previousPage: [this.page.previousLabel, this.page.previousLink],
        forwardPage: [this.page.forwardLabel, this.page.forwardLink],
      }
    },
  },

  methods: {
    sectionType (widget) {
      const largeSection = {
        'widget-search-cta': true,
        'widget-nota-quero': true,
        'widget-simulator': true,
      }
      return largeSection[widget] ? 'financial-aid-article__section--large' : 'financial-aid-article__section--small'
    },
  },
}
</script>

<style lang="scss" scoped>
.financial-aid-article {
  column-gap: var(--unit-0800);
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin-top: var(--unit-0600);
  row-gap: var(--unit-1200);

  @media (min-width: $breakpoint-desktop) {
    grid-template-columns: repeat(12, 1fr);
    margin-top: var(--unit-0800);
  }
}

.financial-aid-article__article {
  grid-column: 1 / -1;

  @media (min-width: $breakpoint-desktop) {
    grid-column: 1 / span 8;
    grid-row: 1 / 1;
  }
}

.financial-aid-article__aside {
  display: grid;
  grid-column: 1 / -1;
  grid-row: 2 / 2;
  grid-template-rows: repeat(2, min-content);
  justify-items: center;
  row-gap: var(--unit-0400);

  @media (min-width: $breakpoint-desktop) {
    grid-column: 10 / -1;
    grid-row: 1 / 2;
  }
}

.financial-aid-article__aside-enem-card {
  display: none;
  width: 100%;

  @media (min-width: 769px) {
    display: block;
    position: sticky;
    top: 20px;
  }
}

.financial-aid-article__section--small {
  margin-top: var(--unit-0600);
}

.financial-aid-article__section--large {
  margin-bottom: var(--unit-1000);
  margin-top: var(--unit-1200);

  @media (min-width: $breakpoint-desktop) {
    margin-bottom: var(--unit-1800);
    margin-top: var(--unit-2000);
  }
}

.financial-aid-article__widget-enem-card {
  margin-bottom: 32px;
  margin-top: 32px;
  display: block;

  @media (min-width: 769px) {
    display: none !important;
  }
}
</style>
